import { EnvironmentActivityChartCard } from '../../../../InfoPage/EnvironmentActivityChartCard';
import { useDashboardProps } from '../../../DashboardContext';

export const EnvironmentActivityChart = () => {
  const { organizationId, selectedWorkspaceIds, short, internal, timeRange } =
    useDashboardProps();

  return (
    <EnvironmentActivityChartCard
      organizationId={organizationId}
      workspaceIds={selectedWorkspaceIds}
      shortSessions={short}
      internalSessions={internal}
      timePeriodValue={timeRange}
      location="analytics_page"
      resourceTypes={[['managed_presentation', 'play'], 'shared_presentation']}
    />
  );
};
